import api from './api';

export const panchangService = {
    getPanchang: async (date: string, lat: number, lon: number, language: string = 'english') => {
        try {
            const response = await api.get('/api/panchang/', {
                params: { date, lat, lon, language }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};
